"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const FirstPage_1 = tslib_1.__importDefault(require("@mui/icons-material/FirstPage"));
const KeyboardArrowLeft_1 = tslib_1.__importDefault(require("@mui/icons-material/KeyboardArrowLeft"));
const KeyboardArrowRight_1 = tslib_1.__importDefault(require("@mui/icons-material/KeyboardArrowRight"));
const LastPage_1 = tslib_1.__importDefault(require("@mui/icons-material/LastPage"));
const Box_1 = tslib_1.__importDefault(require("@mui/material/Box"));
const IconButton_1 = tslib_1.__importDefault(require("@mui/material/IconButton"));
const Typography_1 = tslib_1.__importDefault(require("@mui/material/Typography"));
/**
 * Note that the standard TablePaginationActions component in mui v5 has support
 * for firstPage and lastPage buttons, so this component might be redundant when
 * upgrading.
 */
const TablePaginationActions = (props) => {
    const { backIconButtonProps = {}, count, nextIconButtonProps = {}, onPageChange, page, rowsPerPage } = props;
    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };
    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };
    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };
    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };
    return (react_1.default.createElement(Box_1.default, { sx: { flexShrink: 0, ml: 2.5 } },
        react_1.default.createElement(IconButton_1.default, { onClick: handleFirstPageButtonClick, disabled: page === 0, "aria-label": "first page", color: "inherit", size: "large" }, react_1.default.createElement(FirstPage_1.default, null)),
        react_1.default.createElement(IconButton_1.default, { onClick: handleBackButtonClick, disabled: page === 0, "aria-label": "previous page", color: "inherit", size: "small", sx: { borderRadius: "4px" }, ...backIconButtonProps },
            react_1.default.createElement(KeyboardArrowLeft_1.default, null),
            react_1.default.createElement(Typography_1.default, { variant: "button" }, backIconButtonProps?.title)),
        react_1.default.createElement(IconButton_1.default, { onClick: handleNextButtonClick, disabled: count !== -1 ? page >= Math.ceil(count / rowsPerPage) - 1 : false, "aria-label": "next page", color: "inherit", size: "small", sx: { borderRadius: "4px" }, ...nextIconButtonProps },
            react_1.default.createElement(Typography_1.default, { variant: "button" }, nextIconButtonProps?.title),
            react_1.default.createElement(KeyboardArrowRight_1.default, null)),
        react_1.default.createElement(IconButton_1.default, { onClick: handleLastPageButtonClick, disabled: page >= Math.ceil(count / rowsPerPage) - 1, "aria-label": "last page", color: "inherit", size: "large" }, react_1.default.createElement(LastPage_1.default, null))));
};
exports.default = TablePaginationActions;
